import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./create.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUsers, FaEye } from "react-icons/fa";

import CategoryTabs from "./playerscategory";
import LiveCategoryTabs from "./LiveCatetgoryTabs";
import Captain from "./Captain";
import { useAuth } from "../../context/AuthContext";
import actions from "../../redux/actions";
import NavbarSidebarWrapper from "../navbarSidebarWrapper";
import { getSelectedTeamPlayers } from "../../utils/playerSession";

export function CreateTeam() {
  const { matchId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [matchDetails, setMatchDetails] = useState(null);
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [next, setNext] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("BAT");
  const [editingTeamId, setEditingTeamId] = useState(null);

  /* ---------------- INITIAL LOAD ---------------- */

  useEffect(() => {
    if (!matchId) return;

    const urlParams = new URLSearchParams(window.location.search);
    const editTeamId = urlParams.get("edit");

    if (editTeamId) {
      setEditingTeamId(parseInt(editTeamId));
    }

    fetchSquadData(editTeamId);
  }, [matchId]);

  /* ---------------- FETCH PLAYERS ---------------- */

  const fetchSquadData = async (editTeamId) => {
    try {
      setLoading(true);

      const { data } = await actions.getPlayersByMatch(matchId);

      if (data?.Status) {
        const squadData = data?.Result || [];

        const formattedPlayers = squadData.map((player) => ({
          id: player.id,
          name: player.name,
          code: player.country?.substring(0, 3).toUpperCase() || "TBD",
          role: mapRole(player.role, player),
          credits: player.credit || (Math.random() * 2 + 8).toFixed(1),
          isSelected: false,
          imageUrl:
            player.playerImg ||
            "https://via.placeholder.com/80x80?text=Player",
        }));
        console.log("ediff1111111111111111vvvvvvvv", editTeamId);

        //  Get previously selected players (for edit mode)
        const selectedTeamPlayers = editTeamId ? getSelectedTeamPlayers(editTeamId) : [];

        //  Mark selected players correctly
        const updatedPlayers = formattedPlayers.map((p) => ({
          ...p,
          isSelected: selectedTeamPlayers.some(
            (mp) => String(mp.id) === String(p.id)
          ),
        }));

        setPlayers(updatedPlayers);

        // Team names setup
        const countries = [
          ...new Set(squadData.map((p) => p.country).filter(Boolean)),
        ];
        const [teamA, teamB] =
          countries.length >= 2 ? countries : ["Team A", "Team B"];

        setMatchDetails({
          teamHomeCode: teamA.substring(0, 3).toUpperCase(),
          teamAwayCode: teamB.substring(0, 3).toUpperCase(),
          teamHomeName: teamA,
          teamAwayName: teamB,
        });
      }
    } catch (err) {
      console.error("Fetch squad error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- ROLE MAPPING ---------------- */

  const mapRole = (role = "", player = {}) => {
    const r = role.toLowerCase();

    if (r.includes("wk") || r.includes("keeper")) return "WK";
    if (r.includes("allround")) return "AR";
    if (r.includes("bat")) return "BAT";
    if (r.includes("bowl")) return "BOW";

    if (player.battingStyle && player.bowlingStyle) return "AR";

    return "BAT";
  };

  /* ---------------- CREDITS ---------------- */

  const calculateCreditsUsed = () => {
    return players
      .filter((p) => p.isSelected)
      .reduce((sum, p) => sum + parseFloat(p.credits), 0);
  };

  const creditsUsed = calculateCreditsUsed();
  const creditsLeft = (100 - creditsUsed).toFixed(1);

  /* ---------------- SELECT PLAYER ---------------- */

  const handleSelect = (id) => {
    setPlayers((prev) => {
      const clicked = prev.find((p) => p.id === id);
      const selected = prev.filter((p) => p.isSelected);

      if (!clicked.isSelected) {
        if (selected.length >= 11) {
          alert("You can select only 11 players.");
          return prev;
        }

        if (creditsUsed + parseFloat(clicked.credits) > 100) {
          alert("Not enough credits left!");
          return prev;
        }
      }

      return prev.map((p) =>
        p.id === id ? { ...p, isSelected: !p.isSelected } : p
      );
    });
  };

  /* ---------------- SAVE TEAM ---------------- */

  const handleSaveTeam = async (
    selectedPlayers,
    captainId,
    viceCaptainId,
    teamName
  ) => {
    const payload = {
      MatchId: matchId,
      CaptainId: captainId,
      ViceCaptainId: viceCaptainId,
      TeamName: teamName,
      Players: selectedPlayers.map((p) => p.id),
      UserId: encodeURIComponent(user.uid),
    };

    if (editingTeamId) {
      payload.Id = editingTeamId;
    }

    await saveTeamApi(payload);
  };

  const saveTeamApi = async (payload) => {
    try {
      const { data, status } = await actions.saveUserTeam(payload);

      if (data.Status && status === 200) {
        alert(
          editingTeamId
            ? "Team updated successfully!"
            : "Team created successfully!"
        );

        navigate(`/contests/${matchId}`);
      } else {
        alert("Failed to save team. " + data.Result);
      }
    } catch (error) {
      console.error("Save team error:", error);
    }
  };

  /* ---------------- LOADING ---------------- */

  if (loading) {
    return (
      <div className="container-fluid text-center py-5">
        <div className="spinner-border text-light"></div>
      </div>
    );
  }

  /* ---------------- UI ---------------- */

  return (
    <NavbarSidebarWrapper>
      <div className="content-wrapper me-0 mb-4">
        <div className="container-fluid create-team-container">
          {!next ? (
            <>
              <div className="row text-center py-2 bg-light">
                <div className="col">
                  <p>{players.filter((p) => p.isSelected).length}/11</p>
                </div>
                <div className="col">
                  <p>Credits Left: {creditsLeft}</p>
                </div>
              </div>

              <CategoryTabs
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
              />

              <LiveCategoryTabs
                players={players}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                handleSelect={handleSelect}
              />

              <div className="d-flex justify-content-between mt-3">
                <button className="btn btn-dark d-flex align-items-center">
                  <FaEye className="me-2" />
                  Preview
                  <FaUsers className="ms-2" />
                </button>

                <button
                  className="btn btn-success"
                  disabled={
                    players.filter((p) => p.isSelected).length !== 11 ||
                    creditsLeft < 0
                  }
                  onClick={() => setNext(true)}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <Captain
              players={players.filter((p) => p.isSelected)}
              onSave={handleSaveTeam}
              onBack={() => setNext(false)}
              isEditing={!!editingTeamId}
            />
          )}
        </div>
      </div>
    </NavbarSidebarWrapper>
  );
}

export default CreateTeam;